import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiStateService {
  /** Controls visibility of the language selector in the layout */
  showLanguageSelector = signal(true);

  hideLanguageSelector(): void {
    this.showLanguageSelector.set(false);
  }

  showLanguageSelectorFn(): void {
    this.showLanguageSelector.set(true);
  }
}
